import { jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync } from '@nu-art/thunderstorm-frontend/index';
import { Renderer_QuickNote } from '../_renderers/Renderer_QuickNote/Renderer_QuickNote.js';
import { Component_AdvisorNotes } from '../advisor-notes/Component_AdvisorNotes.js';
export class Component_SmartDocs extends ComponentSync {
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state.quickNoteMode = nextProps.quickNoteMode;
        return state;
    }
    //######################### Logic #########################
    //######################### Render #########################
    render() {
        if (this.state.quickNoteMode)
            return _jsx(Renderer_QuickNote, { onCloseEditor: this.props.onCloseQuickNote });
        return _jsx(Component_AdvisorNotes, {});
    }
}
//# sourceMappingURL=Component_SmartDocs.js.map